export const LIST_MODES = {
  REGULAR: "regular",
  SELECT: "select",
};

export const SELECT_TYPE = {
  SELECT: "select",
  MOVE: "move",
};
